import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { PlanStep } from '../../../services/PlanStep';
import { StepComponent } from '../../step.component';
import { StrtPriority } from '../../../../shared/models/plan/StrtPriority';
import {StrtKeyMeasure, StrtKeyMeasurePending} from '../../../../shared/models/plan/StrtKeyMeasure';
import { KeyMeasureComponent } from './key-measure/key-measure.component';
import { StrtInitiative } from '../../../../shared/models/plan/StrtInitiative';
import { PlanCoordinate } from '../../../services/plan-coordinate';
import { OutcomeComponent } from './outcome/outcome.component';
import { StrtOutcome } from '../../../../shared/models/plan/StrtOutcome';
import {Observable, Subscription} from 'rxjs/index';
import {StrategiesDataStoreService} from '../../../../shared/services/strategies-data-store.service';
import {KeyMeasureService} from '../../../services/key-measure.service';
import {AppLoadingService} from '../../../../app-loading-panel/app-loading.service';
import {PriorityService} from '../../../services/priority.service';
import {Dialog} from 'primeng/primeng';
import {OutcomeService} from '../../../services/outcome.service';
import {StrtObjective} from '../../../../shared/models/plan/StrtObjective';
import {StrtCreateKeyMeasures} from '../../../../shared/models/api/StrtCreateKeyMeasures';
import * as _ from 'lodash';
import {ResourceService} from '../../../services/resource.service';
// import {AssumptionFlyoutComponent} from './assumption-flyout/assumption-flyout.component';
// import {StrtAssumption} from '../../../../shared/models/plan/StrtAssumption';
// import {InfluentialFactorFlyoutComponent} from './influential-factor-flyout/influential-factor-flyout.component';
// import {StrtInfluentialFactor} from '../../../../shared/models/plan/StrtInfluentialFactor';
// import {InitiativeService} from '../../../services/initiative.service';

@Component({
  selector: 'app-identifying-outcomes-key-measures',
  templateUrl: './identifying-outcomes-key-measures.component.html',
  styleUrls: ['./identifying-outcomes-key-measures.component.scss']
})
export class IdentifyingOutcomesKeyMeasuresComponent extends StepComponent<StrtOutcome|StrtKeyMeasure> implements OnInit, OnDestroy {
  private readonly MAX_OUTCOME_COUNT = 10;
  private readonly MAX_KEY_MEASURE_COUNT = 10;
  // private readonly MAX_ASSUMPTION_COUNT = 10;
  // private readonly MAX_INFLUENTIAL_FACTOR_COUNT = 10;

  @ViewChild(KeyMeasureComponent) keyMeasureComp: KeyMeasureComponent;
  @ViewChild(OutcomeComponent) outcomeComp: OutcomeComponent;
  // @ViewChild(AssumptionFlyoutComponent) assumptionFlyout: AssumptionFlyoutComponent;
  // @ViewChild(InfluentialFactorFlyoutComponent) influentialFactorFlyout: InfluentialFactorFlyoutComponent;
  @ViewChild('comfirmDeleteKeyMeasureDialog') comfirmDeleteKeyMeasureDialog: Dialog;

  @Input() keyMeasures: StrtKeyMeasure[] = [];
  @Input() strategyId: number;

  planHasInitiatives = false;

  keyMeasureToDelete: StrtKeyMeasure;
  keyMeasureDeleteActive = false;
  reusedKeyMeasureDeleteActive = false;
  keyMeasureDeleteMethod = 'single';
  hasKeyMeasures = false;
  // hasAssumptions = false;
  // hasInfluentialFactors = false;

  outcomeToDelete: StrtOutcome;
  outcomeDeleteActive = false;
  confirmEditKMActive = false;

  // assumptionToDelete: StrtAssumption;
  // assumptionDeleteActive = false;


  private prioritiesSubscription: Subscription;
  priorities: StrtPriority[] = [];
  isLoading$: Observable<boolean>;
  private _pendingKMEdit?: {
    initiative: StrtInitiative,
    keyMeasure: StrtKeyMeasure
  };

  // TODO Add back initiative service for CRUD calls for assumptions and influential factors
  // private _initiativeService: InitiativeService,
  constructor(private _strtDataStore: StrategiesDataStoreService,
              private _keyMeasureService: KeyMeasureService,
              private _outcomeService: OutcomeService,
              private _priorityService: PriorityService,
              private _loadingService: AppLoadingService,
              _resourceService: ResourceService) {
    super(PlanCoordinate.stepBy(PlanStep.IDENTIFY_OUTCOMES_AND_KEY_MEASURES), _resourceService);
  }

  ngOnInit() {
    this._loadingService.setLoading();
    this.isLoading$ = this._loadingService.isLoading$;
    this.prioritiesSubscription = this._strtDataStore.priorities$.subscribe((priorities: StrtPriority[]) => {
      this.priorities = priorities || [];
      this.updateHasFlags(this.priorities);
      this._loadingService.clearLoading();
    });
    this._priorityService.fetchPriorities(this.strategyId);
  }

  ngOnDestroy(): void {
    if (this.prioritiesSubscription) {
      this.prioritiesSubscription.unsubscribe();
    }
    this.priorities = [];
  }

  updateHasFlags(priorities: StrtPriority[]) {
    this.planHasInitiatives = false;
    this.hasKeyMeasures = false;
    if (priorities.length === 0) {
      return;
    }
    priorities.map((priority: StrtPriority) => {
      priority.objectives.map((objective: StrtObjective) => {
        this.planHasInitiatives = this.planHasInitiatives || objective.initiatives.length > 0;
        objective.initiatives.map((initiative: StrtInitiative) => {
          this.hasKeyMeasures = this.hasKeyMeasures || (initiative.keyMeasures && initiative.keyMeasures.length > 0);
          // this.hasAssumptions = this.hasAssumptions || (initiative.assumptions && initiative.assumptions.length > 0);
          // this.hasInfluentialFactors = this.hasInfluentialFactors ||
          //   (initiative.influentialFactors && initiative.influentialFactors.length > 0);
        });
      });
    });
  }

  isAddOutcomesDisabled(initiative: StrtInitiative): boolean {
    return this.isAddItemDisabled || initiative.outcomes.length >= this.MAX_OUTCOME_COUNT;
  }

  get outcomesMeasuresColWidth() {
    return !this.isEditItemDisabled && !this.isDeleteItemDisabled ? '2' : '1';
  }

  get isOutcomeActive() {
    return this.outcomeComp.isActive;
  }

  set isOutcomeActive(isActive) {
    this.outcomeComp.isActive = isActive;
  }

  get planHasPriorities() {
    return this.priorities.length > 0;
  }

  isAddKeyMeasuresDisabled(initiative: StrtInitiative) {
    return this.isAddItemDisabled || initiative.keyMeasures.length >= this.MAX_KEY_MEASURE_COUNT;
  }

  // isAddAssumptionDisabled(initiative: StrtInitiative) {
  //   return this.isAddItemDisabled || (initiative.assumptions && initiative.assumptions.length >= this.MAX_ASSUMPTION_COUNT);
  // }
  //
  // isAddInfluentialFactorDisabled(initiative: StrtInitiative) {
  //   return this.isAddItemDisabled ||
  //     (initiative.influentialFactors && initiative.influentialFactors.length >= this.MAX_INFLUENTIAL_FACTOR_COUNT);
  // }

  get isKeyMeasureActive() {
    return this.keyMeasureComp.isActive;
  }

  set isKeyMeasureActive(isActive: boolean) {
    this.keyMeasureComp.isActive = isActive;
  }

  // get isAssumptionFlyoutActive() {
  //   return this.assumptionFlyout.isActive;
  // }
  //
  // set isAssumptionFlyoutActive(isActive: boolean) {
  //   this.assumptionFlyout.isActive = isActive;
  // }
  //
  // get isInfluentialFactorFlyoutActive() {
  //   return this.influentialFactorFlyout.isActive;
  // }
  //
  // set isInfluentialFactorFlyoutActive(isActive: boolean) {
  //   this.influentialFactorFlyout.isActive = isActive;
  // }

  get objectivePriorities(): StrtPriority[] {
    return this.priorities.filter(it => it.objectives.some(objective => objective.initiatives.length > 0));
  }

  /****************************************************************
   * Click Handlers
   ****************************************************************/

  onClickAddKeyMeasures(initiative: StrtInitiative) {
    this.keyMeasureComp.createKeyMeasures(initiative, this.priorities);
  }

  // onClickAddAssumption(initiative: StrtInitiative) {
  //   this.assumptionFlyout.createAssumptions(initiative, this.priorities);
  // }
  //
  // onClickAddInfluentialFactor(initiative: StrtInitiative) {
  //   this.influentialFactorFlyout.createInfluentialFactor(initiative, this.priorities);
  // }
  //
  // onClickEditAssumption(initiative: StrtInitiative, assumption: StrtAssumption) {
  //   this.assumptionFlyout.editAssumption(initiative, assumption, this.priorities);
  // }
  //
  // onClickEditInfluentialFactor(initiative: StrtInitiative, influentialFactor: any) {
  //   this.influentialFactorFlyout.editInfluentialFactor(initiative, influentialFactor, this.priorities);
  // }
  //
  // onClickDeleteAssumption(initiative: StrtInitiative, assumption: StrtAssumption) {
  //   // TODO: Add call to present confirm delete modal for assumptions
  //   this.assumptionToDelete = assumption;
  //   console.log(`Assumption To Delete: `, assumption);
  //   this.assumptionDeleteActive = true;
  // }
  //
  // onClickDeleteInfluentialFactor(initiative: StrtInitiative, influentialFactor: any) {
  //   // TODO: Add call to present confirm delete modal for influential factor
  // }

  onClickEditKeyMeasure(initiative: StrtInitiative, keyMeasure: StrtKeyMeasure) {
    if (keyMeasure.reused) {
      this._pendingKMEdit = {
        initiative: initiative,
        keyMeasure: keyMeasure
      };
      this.confirmEditKMActive = true;
    } else {
      this.keyMeasureComp.editKeyMeasure(initiative, keyMeasure);
    }
  }

  onClickDeleteKeyMeasure(initiative: StrtInitiative, keyMeasure: StrtKeyMeasure) {
    this.keyMeasureDeleteActive = !keyMeasure.reused;
    this.reusedKeyMeasureDeleteActive = keyMeasure.reused;
    keyMeasure.initiativeId = initiative.initiativeId;
    this.keyMeasureToDelete = keyMeasure;
  }

  onClickAddOutcomes(initiative: StrtInitiative) {
    this.outcomeComp.createOutcome(initiative);
  }

  onClickEditOutcome(initiative: StrtInitiative, outcome: StrtOutcome) {
    this.outcomeComp.editOutcome(initiative, outcome);
  }

  onClickDeleteOutcome(outcome: StrtOutcome) {
    this.outcomeToDelete = outcome;
    this.outcomeDeleteActive = true;
  }

  createKeyMeauresPayload(keyMeasures: StrtKeyMeasurePending[]): StrtCreateKeyMeasures {
    const payload: StrtCreateKeyMeasures = {
      newKeyMeasures: [],
      reuseKeyMeasures: []
    };
    for (const keyMeasure of keyMeasures) {
      if (keyMeasure.createMethod === 'select') {
        payload.reuseKeyMeasures.push(_.pick(keyMeasure, ['initiativeId', 'keyMeasureId', 'measure', 'sort', 'tagId']) as StrtKeyMeasure);
      } else {
        payload.newKeyMeasures.push(_.pick(keyMeasure, ['initiativeId', 'keyMeasureId', 'measure', 'sort', 'tagId']) as StrtKeyMeasure);
      }
    }
    return payload;
  }

  /****************************************************************
   * Service Layer Integrations
   ****************************************************************/


  // onAssumptionsCreate(assumptions: StrtAssumption[]) {
  //   console.log(`On Assumptions Create`);
  //   this.assumptionFlyout.isActive = false;
  // }
  //
  // onAssumptionEdit(assumption: StrtAssumption) {
  //   console.log(`On Assumption Edit`);
  //   this.assumptionFlyout.isActive = false;
  // }
  //
  // onInfluentialFactorCreate(influentialFactors: StrtInfluentialFactor[]) {
  //   console.log(`On Influential Factor Create`);
  //   this.influentialFactorFlyout.isActive = false;
  // }
  //
  // onInfluentialFactorEdit(influentialFactor: StrtInfluentialFactor) {
  //   console.log(`On Influential Factor Edit`);
  //   this.influentialFactorFlyout.isActive = false;
  // }

  /**
   * Creates a new key measure
   * @param {StrtKeyMeasure[]} keyMeasures
   */
  onKeyMeasuresCreate(keyMeasures: StrtKeyMeasurePending[]) {
    const payload: StrtCreateKeyMeasures = this.createKeyMeauresPayload(keyMeasures);
    const initiativeId = this.keyMeasureComp.parentId;
    this._loadingService.setLoading();
    this._keyMeasureService.createKeyMeasures(this.strategyId, initiativeId, payload)
      .subscribe((responseObject: {
        keyMeasureDTOList: StrtKeyMeasure[]
      }) => {
        // Inject initiative id so we can put it back into the data store.
        // If response payload is changed to include initiative id then this can be removed.
        responseObject.keyMeasureDTOList.map((keyMeasure: StrtKeyMeasure) => {
          keyMeasure.initiativeId = initiativeId;
        });
        this._strtDataStore.addKeyMeasures(responseObject.keyMeasureDTOList, this.priorities);
        this.isKeyMeasureActive = false;
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error Creating Key Measure: `, err);
      });
  }

  /**
   * Edits an existing key measure
   * @param {StrtKeyMeasure} keyMeasure
   */
  onKeyMeasureEdit(keyMeasure: StrtKeyMeasurePending) {
    this._loadingService.setLoading();
    const initiativeId = this.keyMeasureComp.parentId;
    this._keyMeasureService.updateKeyMeasure(this.strategyId, initiativeId, keyMeasure)
      .subscribe((updatedData: StrtKeyMeasure) => {
        const updatedKeyMeasure: StrtKeyMeasure = _.pick(keyMeasure,
          ['initiativeId', 'keyMeasureId', 'measure', 'sort', 'tagId', 'reused']);
        updatedKeyMeasure.measure = updatedData.measure;
        updatedKeyMeasure.tagId = updatedData.tagId;
        updatedKeyMeasure.reused = updatedData.reused;
        this._strtDataStore.editKeyMeasure(updatedKeyMeasure, this.priorities);
        this.isKeyMeasureActive = false;
        this._pendingKMEdit = null;
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error Editing Key Measure: `, err);
      });
  }

  /**
   * Deletes a specific key measure
   */
  onKeyMeasureDelete() {
    const keyMeasure = this.keyMeasureToDelete;
    this._loadingService.setLoading();
    this._keyMeasureService.deleteKeyMeasure(this.strategyId, keyMeasure)
      .subscribe(() => {
        this._strtDataStore.deleteKeyMeasure(keyMeasure, this.priorities);
        this.resetKeyMeasureDeleteModal();
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error deleting key measure: `, err);
      });
  }

  /**
   * Deletes a reused key measure
   * Note: uses a different API endpoint than regular delete
   */
  onReusedKeyMeasureDelete() {
    if (this.keyMeasureDeleteMethod === 'single') {
      this.onKeyMeasureDelete();
    } else {
      const keyMeasure = this.keyMeasureToDelete;
      this._loadingService.setLoading();
      this._keyMeasureService.deleteReusedKeyMeasure(this.strategyId, keyMeasure)
        .subscribe(() => {
          this._strtDataStore.deleteKeyMeasureFromAll(keyMeasure, this.priorities);
          this.resetKeyMeasureDeleteModal();
        }, (err) => {
          this._loadingService.clearLoading();
          console.error(`Error deleting key measure: `, err);
        });
    }
  }

  resetKeyMeasureDeleteModal() {
    this.keyMeasureDeleteActive = false;
    this.reusedKeyMeasureDeleteActive = false;
    this.keyMeasureDeleteMethod = 'single';
  }

  /**
   * Creates new outcomes
   * @param {StrtOutcome[]} outcomes
   */
  onOutcomeCreate(outcomes: StrtOutcome[]) {
    this._loadingService.setLoading();
    this._outcomeService.createOutcome(this.strategyId, outcomes)
      .subscribe((newOutcomes: StrtOutcome[]) => {
        this._strtDataStore.updateOutcomes(newOutcomes, this.priorities);
        this.isOutcomeActive = false;
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error Creating Outcome: `, err);
      });
  }

  /**
   * Edits an outcome
   * @param {StrtOutcome} outcome
   */
  onOutcomeEdit(outcome: StrtOutcome) {
    this._loadingService.setLoading();
    this._outcomeService.updateOutcome(this.strategyId, outcome)
      .subscribe((editedOutcome: StrtOutcome) => {
        this._strtDataStore.updateOutcome(editedOutcome, this.priorities);
        this.isOutcomeActive = false;
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error Editing Outcome: `, err);
      });
  }

  /**
   * Deletes a specific outcome
   */
  onOutcomeDelete() {
    this._loadingService.setLoading();
    this._outcomeService.deleteOutcome(this.strategyId, this.outcomeToDelete)
      .subscribe(() => {
        this._strtDataStore.updateOutcome(Object.assign(this.outcomeToDelete, {initiativeId:  undefined}), this.priorities);
        this.outcomeDeleteActive = false;
        this.outcomeToDelete = null;
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error Deleting Outcome: `, err);
      });
  }

  /**
   * Generic Error Handling
   * @param {Error} error
   */
  onItemError(error: Error) {
    this.isKeyMeasureActive = false;
    this.isOutcomeActive = false;
    super.onItemError(error);
  }


  onConfirmEditKM() {
    if (!this._pendingKMEdit) {
      console.error(`Failed to pickup pending key measure for edit`);
      return;
    }
    this.confirmEditKMActive = false;
    setTimeout(() => {
      this.keyMeasureComp.editKeyMeasure(this._pendingKMEdit.initiative, this._pendingKMEdit.keyMeasure);
    });
  }

  // onConfirmDeleteAssumption() {
  //   this._loadingService.setLoading();
  //   this._initiativeService.deleteAssumption(this.strategyId, this.assumptionToDelete.initiativeId, this.assumptionToDelete)
  //     .subscribe((response: any) => {
  //       console.log(`Delete Assumption Response`);
  //       this._strtDataStore.updateAssumption(Object.assign(this.assumptionToDelete, {initiativeId: undefined}), this.priorities);
  //       this.assumptionDeleteActive = false;
  //       this.assumptionToDelete = null;
  //   }, (err) => {
  //       this._loadingService.clearLoading();
  //     });
  // }
}
